import React, { useState, useContext } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { validateEmail } from "../utils/input-validation";
import SignupButton from "../components/UI/SignupButton";
import classes from "../styles/SignIn.module.css";

import Button from "../components/UI/Button";
import Logo from "../components/Layout/Logo";

import { loginApi } from "../services/api/login";
import { AuthContext } from "../store/auth-context";
import { URL } from "../constants";

const SignIn = () => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const redirect_to = searchParams.get("redirect_to");

  const [continueNext, setContinueNext] = useState(false);
  const [creds, setCreds] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   setError("");
  //   if (loading) return;

  //   setLoading(true);

  //   loginApi
  //     .post?.(creds)
  //     .then((response) => {
  //       setLoading(false);
  //       authCtx.login(response);
  //       if (redirect_to) {
  //         navigate(`${redirect_to}`);
  //       }
  //       if (response?.user?.tenants && response?.user?.tenants.length === 1) {
  //         authCtx.setTenant(response.user.tenants[0].slug);
  //         navigate(`/${response.user.tenants[0].slug}`, {
  //           replace: true,
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       setError("Something went wrong. Please try again later.");
  //       console.log(err);
  //     });
  // };

  // const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setError("");
  //   const { name, value } = event.target;
  //   setCreds({
  //     ...creds,
  //     [name]: value,
  //   });
  //   if (name === "email") {
  //     let isValidEmail = validateEmail(value);
  //     setContinueNext(isValidEmail);
  //   }
  // };

  return (
    <div className={`container ${classes.alignVerticalCenter}`}>
      <div className={classes.signinWrapper}>
        <header className="d-flex justify-content-center align-items-center mb-3">
          <Logo width="auto" height="50px" alt="Logo" />
        </header>
        <main className="">
          <div className={[classes.Signin, "position-relative"].join(" ")}>
            <h1 className="title text-center">Sign in</h1>
            <p className={`subtitle text-center ${classes.subtitle}`}>
              Continue to {window.location.hostname}
            </p>
            <ul className="mt-5 text-center">
              <SignupButton
                link={`${process.env.REACT_APP_GOOGLE_LOGIN}?redirect_to=${redirect_to}`}
                for="google"
              >
                Sign in with Google
              </SignupButton>
              <SignupButton
                link={`${process.env.REACT_APP_MICROSOFT_LOGIN}?redirect_to=${redirect_to}`}
                for="microsoft"
              >
                Sign in with Microsoft
              </SignupButton>
              {/* <p className="text-muted">
                <span>OR</span>
              </p>
              <form noValidate onSubmit={onSubmit}>
                <input
                  type="text"
                  name="email"
                  className="form-control email bg-light border-0 p-3 font-weight-semibold d-block"
                  placeholder="Email"
                  aria-label="email"
                  value={creds.email}
                  onChange={onChangeHandler}
                />
                <input
                  type="password"
                  name="password"
                  className="form-control bg-light border-0 p-3 font-weight-semibold d-block mt-2"
                  placeholder="Password"
                  aria-label="password"
                  value={creds.password}
                  onChange={onChangeHandler}
                />
                <Button
                  type="submit"
                  text={`${loading ? "" : "Sign in"}`}
                  className={`${continueNext ? "" : "disabled"}`}
                  margin="10px 0 0 0"
                  width="100%"
                >
                  {loading && (
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </Button>
                {error && (
                  <div className="alert alert-danger mt-4" role="alert">
                    {error}
                  </div>
                )}
              </form> */}
              {/* <p className='mt-4'>Dont have an account? <Link to={URL.signUp}>Create a free account</Link></p> */}
            </ul>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SignIn;
